module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-17-2a01b3070e0d050d230008a2650ec91a.jpg";